import axios from 'axios'
// import crypto from 'crypto'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
}

const mutations = {

}


const actions = {
  // 创建订单
PostPay({ commit },data) {
  commit('POST_PAY')
  return axios.post('/order/',data).then((res) => {
    return res
  })
},
// 订单支付
GetAlipay({ commit },data) {
  commit('GET_ALIPAY')
  return axios.get('/payment/order_id/?order_id=' + data.order_id + '&token=' + data.token).then((res) => {
    return res
  })
},
//支付宝支付完成
getPayment({ commit },data) {
  commit('GET_PAYMENT');
  return axios.get('/payment/status/?' + data).then((res) => {
    return res
  })
}
}

const getters = {

}

const PayModule = {
  state,
  mutations,
  actions,
  getters
}

export default PayModule
